import toArray from 'lodash/toArray';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import flatten from 'lodash/flatten';

import { actionLabel } from '../../utils/gradingReports';

const actionTypeToGradingSection = {
  MEDICATION: 'medications',
  PROCEDURE: 'treatments',
  OXYGEN: 'oxygenRoutes',
  QUESTION: 'questions',
  COMMAND: 'commands',
  CALL: 'calls',
  PALPABLE_PULSE: 'assessments',
  COMPRESSION: 'treatments',
  PERSONAL_PROTECTIVE_EQUIPMENT: 'treatments',
  LEADS: 'treatments',
  PACING: 'treatments',
};

const actionTypeToCaseLogicIdKey = {
  OXYGEN: 'routes',
  LEADS: 'leads',
};

const actionTypeToCaseData = {
  MEDICATION: 'dosageForms',
  QUESTION: 'dialogue.questions',
  COMMAND: 'dialogue.commands',
  CALL: 'dialogue.calls',
};

function validateGradingConflicts(caseConf) {
  const errors = [];
  const warnings = [];
  const nodes = get(caseConf, 'caseLogicDescription.nodes', []);
  const gradeEffectNodes = toArray(nodes).filter(
    (node) =>
      node.name === 'Effect' && get(node, 'data.effect.type') === 'GRADING'
  );
  gradeEffectNodes.forEach((effectNode) => {
    const inputActionNodes = getInputActionNodes(effectNode, nodes);
    inputActionNodes.forEach((actionNode) => {
      const actionData = actionNode.data.action;
      if (!actionData) {
        return;
      }
      const caseLogicIdKey =
        actionTypeToCaseLogicIdKey[actionData.type] || 'id';
      const sectionGradingItems = caseConf.grading && 
        caseConf.grading[actionTypeToGradingSection[actionData.type]];
      const actionIdMatches = (id) =>
        id === actionData[caseLogicIdKey] ||
        (isArray(actionData[caseLogicIdKey]) &&
          actionData[caseLogicIdKey].includes(id));
      const matchingGradingItem = (sectionGradingItems || []).find(
        (gradingItem) => {
          return (
            (actionIdMatches(gradingItem.id) ||
              actionIdMatches(gradingItem.componentKey)) &&
            gradingItem.grade !== 'NEUTRAL'
          );
        }
      );
      if (!matchingGradingItem) {
        return;
      }
      let label;
      const caseData = get(caseConf, actionTypeToCaseData[actionData.type]);
      if (caseData) {
        if (actionData.type === 'MEDICATION') {
          label = 'Medication'; // medication labels aren't accessible with only caseConf data
        } else {
          const caseDataItem = caseData.find((item) => item.id === actionData.id);
          label =
            get(caseDataItem, 'label.en') ||
            get(caseDataItem, 'label') ||
            get(caseDataItem, 'name.en') ||
            get(caseDataItem, 'name') ||
            get(caseDataItem, 'content.en') ||
            get(caseDataItem, 'content') || '';
          label = label && label.length > 20 ? label.slice(0, 17) + '...' : label;
        }
      } else {
        label = actionLabel({
          type: actionData.type,
          typeID: actionIdMatches(matchingGradingItem.id)
            ? matchingGradingItem.id
            : matchingGradingItem.componentKey,
        });
      }
      warnings.push({
        message: `${label} is also assigned Grading in Case Logic`,
        category: 'grading',
        field: 'grading',
        metadata: {
          section: actionTypeToGradingSection[actionData.type],
          gradingItem: matchingGradingItem,
          defaultVisibility: false,
        },
      });
      warnings.push({
        message: `${label} is already being graded in the Grading tab`,
        category: 'caseLogic',
        field: 'caseLogicDescription',
        id: effectNode.id,
        metadata: {
          nodeId: effectNode.id,
          defaultVisibility: false,
        },
      });
    });
    // if (!getInputActionNodes(effectNode, nodes)) {
    //   errors.push({
    //     message: 'Grading effect must have action or timer in input chain',
    //     category: 'caseLogic',
    //     field: 'caseLogicDescription',
    //     id: effectNode.id,
    //     metadata: {
    //       nodeId: effectNode.id,
    //     },
    //   });
    // }
    // if (!effectNode.data.effect.label) {
    //   errors.push({
    //     message: 'Grading effect must have name',
    //     category: 'caseLogic',
    //     field: 'caseLogicDescription',
    //     id: effectNode.id,
    //     metadata: {
    //       nodeId: effectNode.id,
    //     },
    //   });
    // }
  });
  return {
    errors,
    warnings,
  };
}

function getInputActionNodes(node, nodeMap, alreadyVisitedNodes = []) {
  // Prevent loops in case logic from triggering
  // an infinite call stack
  if (alreadyVisitedNodes.includes(node)) {
    return [];
  }
  if (node.name === 'Action') {
    return [node];
  } else {
    const connections = get(node, 'inputs.inputs.connections', []);
    return flatten(
      connections.map((connection) => {
        const inputNode = nodeMap[connection.node];
        return getInputActionNodes(inputNode, nodeMap, alreadyVisitedNodes.concat(node));
      })
    );
  }
}

export default validateGradingConflicts;
